import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { PromotionsService } from '../../promotions.service';

@Component({
  selector: 'app-festival-promotions-smart',
  template: `<app-festival-promotions [ocassionRewards]="ocassionRewards" [startDate]="startDate"
  [endDate]="endDate"></app-festival-promotions>`,
  styles: [
  ]
})
export class FestivalPromotionsSmartComponent extends FeaturesBaseComponent implements OnInit {
  ocassionRewards: [] = [];
  dateSelected: any;
  currentDate: Date;
  futureDate: any;
  endDate: any;
  startDate: any;

  constructor(private promotionService: PromotionsService) {
    super()
    this.getOccasionsDefaultData();
  }
  getOccasionsDefaultData() {
    this.currentDate = new Date();
    this.futureDate = this.currentDate.setDate(this.currentDate.getDate() + 10);
    this.startDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.endDate = formatDate(this.futureDate, 'yyyy-MM-dd', 'en');
    console.log(`startdate is : ${this.startDate} & enddate is : ${this.endDate}`)
    this.promotionService.getOccasionFestivalsHistory(this.endDate, this.startDate)
      .subscribe(res => {
        this.ocassionRewards = res['data'];
      });
  }
  // getOccasionsDefaultData() {
  //   this.promotionService.getOccasionFestivals()
  //     .subscribe(res => {
  //       this.ocassionRewards = res['data'];
  //     });
  // }

  ngOnInit(): void {
    super.ngOnInit();
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }

}
